var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"sqpie-chart",attrs:{"id":_vm.questionData.question_id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }